import type { SuiteModuleEntry } from "./registry";
import { SUITE_MODULE_REGISTRY, SUITE_PLATFORM_MODULE_IDS } from "./registry";

export function userHasModuleAccess(
  permissions: string[],
  entry: SuiteModuleEntry,
): boolean {
  if (!permissions.length) return false;
  return permissions.some((permission) =>
    entry.permissionPrefixes.some((prefix) => permission.startsWith(prefix)),
  );
}

export interface ResolveAccessibleModulesOptions {
  /** Sous-ensemble explicite (null = pas de restriction utilisateur). */
  userModuleGrants?: string[] | null;
  /** Admin tenant : accès à tous les modules licenciés. */
  isTenantAdmin?: boolean;
}

/**
 * Intersection : modules licenciés (tenant) ∩ droits utilisateur ∩ registre suite.
 * Si `userModuleGrants` est défini (tableau), seuls ces modules sont exposés.
 */
export function resolveAccessibleModules(
  licensedModules: string[],
  permissions: string[],
  registry: SuiteModuleEntry[] = SUITE_MODULE_REGISTRY,
  options: ResolveAccessibleModulesOptions = {},
): SuiteModuleEntry[] {
  const licensed = new Set(
    licensedModules.filter((id) => !SUITE_PLATFORM_MODULE_IDS.has(id)),
  );

  const { userModuleGrants, isTenantAdmin } = options;
  const grantFilter =
    !isTenantAdmin && userModuleGrants && userModuleGrants.length > 0
      ? new Set(userModuleGrants)
      : null;

  return registry.filter((entry) => {
    if (!licensed.has(entry.id)) return false;
    if (grantFilter && !grantFilter.has(entry.id)) return false;
    if (isTenantAdmin) return true;
    return userHasModuleAccess(permissions, entry);
  });
}
